// angular imports
import { Component, Injector, OnInit } from '@angular/core';

// component imports
import { WorkOrderManageInvoiceBaseComponent } from '../../../_base/work-order-manage-invoice-base-component';

// model imports
import { BaseWorkOrderParameterDto } from '../../../_models/base-work-order-parameter-dto';
import { WorkFlowWorkOrderLinkResultDto } from '../../../_models/workflow-work-order-link-result-dto';

@Component({
    selector: 'app-manage-open-invoices',
    templateUrl: './manage-open-invoices.component.html',
    styleUrls: ['./manage-open-invoices.component.scss']
})
export class ManageOpenInvoicesComponent extends WorkOrderManageInvoiceBaseComponent implements OnInit {
    openInvoices: Array<WorkFlowWorkOrderLinkResultDto> = [];

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.populateOpenInvoices();
    }

    private populateOpenInvoices(): void {
        const baseParams: BaseWorkOrderParameterDto = new BaseWorkOrderParameterDto();
        baseParams.workOrderId = this.workOrderId;
        baseParams.communityId = this.communityId;

        this.workOrderHelperService.showLoading();
        this.workOrderService.getOpenInvoices(baseParams).subscribe(
            (result: WorkFlowWorkOrderLinkResultDto[]) => {
                this.openInvoices = result;
                this.workOrderHelperService.hideLoading();
            },
            (error) => {
                this.workOrderHelperService.hideLoading();
                this.errorService.displayError(error);
            }
        );
    }
}
